export const area = {
    zh: {
        banner: {
            title: '鳳凰衛視“發現新主播”第二季-粵港澳大灣區專場招募行動開啟',
            post: 'https://x0.ifengimg.com/ucms/2025_34/A6C0720D6B9D31A7318F1D88BEFD06F4FC0A60A3_size1329_w750_h1334.png',
            info: 'https://x0.ifengimg.com/ucms/2025_24/B0A622FEF7249B56412B00E231FE4B14DD33FF65_size19_w750_h166.png',
            infoText:
                '鳳凰衛視「發現新主播」第二季-粵港澳大灣區專場招募行動開啟。主持人、主播、出鏡記者職位虛席以待，工作地點可在香港、北京或海外。不限職業、資歷，只要你有料、有趣、有理想，熱愛國際傳播事業，就來試試吧。',
            demand: 'https://x0.ifengimg.com/ucms/2025_24/B13AE4F0B84BBFE3D7AAFDA64A55CB708238ECB2_size11_w750_h130.png',
            demandText: '年滿18周歲，大學本科及以上學歷。',
        },
        name: {
            title: '姓名',
            waring1: '請輸入姓名',
            waring2: '已超過最大字數',
        },
        gender: {
            title: '性別',
            man: '男',
            woman: '女',
            selectDefault: '未選擇',
            cancelText: '取消',
            confirmText: '確定',
            waring1: '請選擇性別',
        },
        age: {
            title: '年齡',
            waring1: '請輸入年齡',
            waring2: '最大兩位數',
            waring3: '請輸入數字',
        },
        education_level: {
            title: '教育程度',
            placeholder: '如博士/碩士/學士……',
            waring1: '請輸入教育程度',
            waring2: '已超過最大字數',
        },
        career: {
            title: '現職',
            placeholder: '如某某公司某某職位',
            waring1: '請輸入現職',
            waring2: '已超過最大字數',
        },
        language: {
            title: '語言能力',
            placeholder: '如熟悉英語/粵語/普通話……',
            waring1: '請輸入語言能力',
            waring2: '已超過最大字數',
        },
        country: {
            title: '國家/地區',
            waring1: '請輸入國家/地區',
            waring2: '已超過最大字數',
        },
        living_city: {
            title: '目前所在城市',
            waring1: '請輸入目前所在城市',
            waring2: '已超過最大字數',
        },
        documents: {
            title: '往返粵港澳三地所持證件',
            placeholder: '回鄉證/港澳通行證/護照/身份證……',
            waring1: '請輸入往返粵港澳三地所持證件',
            waring2: '已超過最大字數',
        },
        mobile_number: {
            title: '手機號',
            waring1: '請輸入手機號',
            waring2: '已超過最大字數',
        },
        email: {
            title: '郵箱',
            waring1: '請輸入郵箱',
            waring2: '已超過最大字數',
        },
        wechat_id: {
            title: '微信',
            waring1: '請輸入微信',
            waring2: '已超過最大字數',
        },
        social_media_accounts: {
            title: '社交網絡賬號',
            placeholder: 'YouTube/Facebook/Instagram/X等ID或鏈接',
            waring1: '請輸入社交網絡賬號',
            waring2: '已超過最大字數',
        },
        major: {
            title: '最高學歷畢業院校及專業/在讀院校及專業',
            placeholder: '某某大學某某專業',
            waring1: '請輸入最高學歷畢業院校及專業/在讀院校及專業',
            waring2: '已超過最大字數',
        },
        work_experience: {
            title: '工作經歷/校園經歷',
            waring1: '請輸入工作經歷/校園經歷',
            waring2: '已超過最大字數',
        },
        self_introduction: {
            title: '自我介紹',
            placeholder: '40字以內',
            waring1: '請輸入自我介紹',
            waring2: '已超過最大字數',
        },
        photo: {
            title: '照片資料',
            placeholder: '參選者兩寸照、半身、全身近照各一張,必須為近期所拍攝，圖片為jpeg、png、gif、jpg類型。',
            reLoadText: '重新上傳',
            defaultImage: 'https://x0.ifengimg.com/ucms/2025_24/0C68D6DBFFF0CCD68F4626BB31128A081CF9B294_size5_w204_h206.png',
            waring1: '圖片文件已超過20MB',
            waring2: '僅支持jpeg、png、gif、jpg文件上傳',
            waring3: '請上傳照片',
        },
        video1: {
            title: '視頻資料',
            placeholder:
                '自我介紹+分享或者評論最近關注的新聞事件，表現形式不限，能體現報名者個性特點，時長控制在2分鐘內。<br /><br />視頻要求：<br/>1) 長寬比16:9，橫幅拍攝，MP4、mov、quicktime格式，大小不超過500MB。<br />2) 畫面清晰，聲音清楚，無特效處理。',
            buttonText: '點擊上傳視頻',
            uploadText: '上傳中',
            uploadDoneText: '已上傳，點擊替換',
            waring1: '視頻文件已超過500M',
            waring2: '請上傳視頻',
        },
        video2: {
            title: '視頻作品',
            placeholder: '請上傳本人出鏡、<span>帶環境、有主題、動態為主的視頻，長度3分鐘以內。不可使用美顏、濾鏡，不可配樂</span>。視頻僅支持mp4、mov格式',
            buttonText: '點擊上傳視頻',
            uploadText: '上傳中',
            uploadDoneText: '已上傳，點擊替換',
            waring1: '視頻文件已超過500M',
            waring2: '請上傳視頻',
        },
        optional: {
            title: '選填鏈接',
            placeholder: '請在此處填寫發佈標題及網頁鏈接，100字以內。',
            waring1: '已超過最大字數',
        },
        optionalInfo: {
            title: '其他相關資料',
            placeholder: '過往跟主播、主持、記者等傳媒相關的經歷，可提供一個視頻文件或者網頁鏈接，視頻文件大小不超過500MB。',
        },
        // limtTime: '報名截止日期：2025年8月15日',
        declaration: {
            title: '本人已細閱本報名表格的條款和條文，並同意受其約束。本人報名提供之各項資料，俱屬真實。',
            moreText: '點擊查看詳情',
            detailTitle: '鳳凰衛視《發現新主播》報名承諾書',
            detailText:
                '《發現新主播》的主辦方是鳳凰衛視，是一項以為主辦方選聘主播人才為目的的選拔行動。參選者在報名前請認真閱讀以下法律文本，在充分瞭解並理解的基礎上同意本承諾書的全部條款後，按照報名頁面上的提示完成報名。<br /><br /><p>1. 遵紀守法承諾</p>本人承諾在報名參加《發現新主播》時已年滿18周歲，具有完全民事行為能力，獨立報名並自願作出本承諾書的各項承諾。本人承諾無違法、違紀不良記錄，在各類媒體、社交平台、自媒體等管道未發表過違反公序良俗、違規或不當言論，且未涉及任何違反法律法規或侵犯第三方權益的內容。本人承諾參選內容符合國家法律法規及公序良俗。本人承諾參加選拔的行為不會受到任何用人單位或其他主體有關法律、合同的約束、禁止或限制。本人承諾參選期間及之後，不會以任何形式損害主辦方聲譽，不發表任何與主辦方或選拔事項相關的虛假或誤導性言論。<br /><br /><p>2. 基本資訊真實性承諾</p>本人保證符合《發現新主播》選拔行動公告中規定的參選資格要求。本人保證報名填寫的內容全面、真實、準確，嚴格按照要求完整填寫資訊，不得以虛假或冒用的身份資訊、個人資料進行報名。如任何資訊被查證失實，主辦方有權取消本人參選資格，並保留追究法律責任的權利。同時將不誠信行為記錄在案，作為未來參選資格審核的參考依據。<br /><br /><p>3. 知識產權承諾</p>本人保證提交的參選資料（包括但不限於文字、圖片、視頻、音頻等）不侵犯任何第三方知識產權（包括但不限於著作權）、肖像權、所有權等合法權益，如因此發生任何爭議糾紛應由本人自行解決並承擔全部責任。若涉及第三方知識產權（如引用素材），本人承諾已取得相關權利人授權，並確保授權範圍滿足本次選拔的使用需求。<br /><br /><p>4. 作品授權條款</p>本人同意並授權鳳凰衛視及合作方：<br />• 在全球範圍內無償永久使用參選資料的全部或部分內容；<br />• 以任何現有及未來出現的方式（包括但不限於新聞傳播、衍生產品開發、商業用途等）進行修改、編輯、技術處理及推廣；<br />• 無需另行取得本人或第三方授權，亦無需向本人或第三方支付額外費用。<br /><br /><p>5. 糾紛責任條款</p>如因本人違反本承諾書，主辦方有權取消本人參選資格、追回獎項或獎勵，並保留向本人追償損失的權利。<br /><br /><p>6.保密義務</p>本人已經(或將要)知悉主辦方關於選拔行動的保密資訊，本人承諾承擔嚴格的保密義務，保密資訊包括但不限於：<br />6.1節目（選拔行動）內容、形式及模式；<br />6.2節目（選拔行動）相關資訊及資料，包括但不限於選手資訊、資料、作品，評委及指導老師資訊，節目評審資訊、選拔各階段題目、結果，內部工作會議及相關資料等；<br />6.3節目（選拔行動）涉及的所有法律文書、文件及其他一切無法自公開管道獲知的與節目有關的資訊；<br />6.4與工作人員的溝通、交流資訊。<br /><br /><p>7.選拔目的</p>本人充分知悉並認可《發現新主播》是一項以為主辦方選聘主播人才為目的的選拔行動。<br /><br /><p>8.免責聲明</p>8.1本人承諾參選期間因自身健康、非主辦方過錯導致的本人人身或財產損失，由本人自行承擔，與主辦方無關。<br />8.2因不可抗力或非主辦方過錯導致的選拔行動調整或終止，本人予以理解並自願放棄追責。<br />8.3因本人提交資料引發任何糾紛（包括但不限於知識產權（包括但不限於著作權）、肖像權、所有權等爭議或糾紛），由本人自行解決並承擔全部責任。主辦方及合作方不因此承擔任何訴訟或賠償義務，且保留向本人追償損失的權利。<br /><br />注：本活動法律支持：北京盈理律師事務所<br />',
            promiseText:
                '<p>本人鄭重承諾：</p><br />本人已充分閱讀並理解、同意本承諾書全部內容。本承諾書項下各項條款、內容，主辦方已向本人充分履行其法律含義的告知、解釋義務。本人提交報名表，即被視為已閱讀、理解並同意本承諾書的全部條款文件、內容，同時本人承諾遵守本次選拔的所有參選規則和要求。本承諾書解釋權歸主辦方所有。',
            agreeText: '取消',
            disagreeText: '我已知曉並確認',
            copyText: '一鍵輸入以上內容',
        },
        button: {
            submit: 'https://x0.ifengimg.com/ucms/2024_38/068056ECBEF7924A8665BF379448E5C08BFF9099_size5_w306_h92.png',
            save: 'https://x0.ifengimg.com/ucms/2024_29/FDD0B60DF960924A028EEFD71A278A72EB67755D_size4_w306_h92.png',
        },
        confirm: {
            title1: '確認提交報名資料嗎？',
            title2: '確認更新報名資料嗎？',
            confirmText: '確認',
            checkIt: '再檢查一下',
        },
        success: {
            title1: '我們已經收到你的資料啦！<br />我們會盡快查看並聯絡你。',
            title2: '我們已經收到你的更新資料啦！<br />我們會盡快查看並聯絡你。',
            info: '問題回饋',
        },
        api: {
            waring1: '未知錯誤，提交失敗，請稍後重試',
            waring2: '請確認報名條約',
        },
        save: {
            title: '保存成功',
        },
        share: {
            title: '鳳凰衛視“發現新主播”第二季-粵港澳大灣區專場招募行動開啟',
            img: 'https://x0.ifengimg.com/ucms/2025_24/22D5A8C7696250DAF1D64ABAD0DD79CD7C374D51_size230_w600_h600.png',
            desc: '想成為鳳凰衛視主持人、主播、出鏡記者就快來報名參加選拔吧！',
        },
    },
    en: {
        banner: {
            // eslint-disable-next-line quotes
            title: "Greater Bay Area Round: Phoenix TV's “Host Hunt” Season 2 recruitment campaign in Guangdong-Hong Kong-Macao Greater Bay Area has begun",
            post: 'https://x0.ifengimg.com/ucms/2025_34/A6C0720D6B9D31A7318F1D88BEFD06F4FC0A60A3_size1329_w750_h1334.png',
            info: 'https://x0.ifengimg.com/ucms/2025_24/A1571211A376EAE350C67A2CACE990171CFD7777_size23_w750_h166.png',
            infoText:
                'Phoenix TV\'s "Host Hunt" Season 2 recruitment campaign in Guangdong-Hong Kong-Macao Greater Bay Area has begun. Positions available include hosts, anchors, and on-camera reporters, with work locations in Hong Kong, Beijing or overseas. We are open to all backgrounds and professions. If you are knowledgeable, interesting, idealistic, and passionate about international communication, we welcome your participation.',
            demand: 'https://x0.ifengimg.com/ucms/2025_25/6DB4CF18115DD592636285861E98D74E9B15A9BD_size15_w750_h82.png',
            // eslint-disable-next-line quotes
            demandText: "You have to be at least 18 years old with a bachelor's degree or above.",
        },
        name: {
            title: 'Name',
            waring1: 'Please enter your name.',
            waring2: 'Exceeds maximum character limit',
        },
        gender: {
            title: 'Gender',
            man: 'Male',
            woman: 'Female',
            selectDefault: 'Unselected',
            cancelText: 'cancel',
            confirmText: 'confirm',
            waring1: 'Please select gender.',
        },
        age: {
            title: 'Age',
            waring1: 'Please enter age.',
            waring2: 'Please enter a number.',
            waring3: 'Maximum two digits.',
        },
        education_level: {
            title: 'Education level',
            // eslint-disable-next-line quotes
            placeholder: "e.g. PhD/Master's/Bachelor's...",
            waring1: 'Please enter educational level.',
            waring2: 'Exceeds maximum character limit.',
        },
        career: {
            title: 'Current Position',
            placeholder: 'e.g. [Position] at [Company]',
            waring1: 'Please enter current position',
            waring2: 'Exceeds maximum character limit.',
        },
        language: {
            title: 'Language Proficiency',
            placeholder: 'Mandarin/Cantonese/English, etc.',
            waring1: 'Please enter language proficiency',
            waring2: 'Exceeds maximum character limit.',
        },
        country: {
            title: 'Country/Region',
            waring1: 'Please enter country/region.',
            waring2: 'Exceeds maximum character limit.',
        },
        living_city: {
            title: 'Current City of Residence',
            waring1: 'Please enter current city of residence',
            waring2: 'Exceeds maximum character limit.',
        },
        documents: {
            title: 'The documents required for traveling between Guangdong, Hong Kong, and Macao',
            placeholder: 'e.g. Mainland Travel Permit for Hong Kong and Macau Residents/ Permit for Travelling to and from Hong Kong and Macao/ Passport/ Identity Card...',
            waring1: 'Please enter the content',
            waring2: 'Exceeds maximum character limit.',
        },
        mobile_number: {
            title: 'Mobile Number',
            waring1: 'Please enter mobile number',
            waring2: 'Exceeds maximum character limit.',
        },
        email: {
            title: 'Email',
            waring1: 'Please enter email',
            waring2: 'Exceeds maximum character limit.',
        },
        wechat_id: {
            title: 'WeChat ID',
            placeholder: 'WeChat',
            waring1: 'Please enter weChat ID',
            waring2: 'Exceeds maximum character limit.',
        },
        social_media_accounts: {
            title: 'Social Media Accounts',
            placeholder: 'YouTube/Facebook/Instagram/X ID or links',
            waring1: 'Please enter social media accounts',
            waring2: 'Exceeds maximum character limit.',
        },
        major: {
            title: 'Previous Institution & Major / Current Institution & Major (if studying)',
            placeholder: 'e.g. [Major] at [University]',
            waring1: 'Please enter the content',
            waring2: 'Exceeds maximum character limit.',
        },
        work_experience: {
            title: 'Work Experience / Campus Activities',
            waring1: 'Please enter work experience / campus activities',
            waring2: 'Exceeds maximum character limit.',
        },
        self_introduction: {
            title: 'Self-Introduction',
            placeholder: 'Maximum 40 characters',
            waring1: 'Please enter self-introduction',
            waring2: 'Exceeds maximum character limit.',
        },
        photo: {
            title: 'Profile Photo Requirements',
            placeholder:
                'Recent photos (taken within the last 3 months) of the candidate: one 2-inch passport-style photo, one half-body portrait (waist-up), and one full-body portrait. Images only support JPEG, PNG, GIF, JPG formats.',
            reLoadText: 'Upload Again',
            defaultImage: 'https://x0.ifengimg.com/ucms/2025_24/7B58E6D927162E2301CF6FC637D435A2B4103375_size7_w204_h206.png',
            waring1: 'Image file exceeds 20MB',
            waring2: 'Image upload only supports jpeg, png, gif, jpg files',
            waring3: 'Please uploaded a photo',
        },
        video1: {
            title: 'Video Requirements',
            placeholder:
                // eslint-disable-next-line quotes
                "Please provide a self-introduction with a commentary or opinion on a recent news story you've followed. Express yourself freely in any format within 2 minutes.<br /><br />Notice:<br />1) Format: 16:9 aspect ratio (landscape), in MP4, MOV, or QuickTime format, with a maximum file size of 500MB.<br />2) Quality: Clear visuals and audio, with no effects or filters.",
            buttonText: 'Upload Video',
            uploadText: 'Uploading',
            uploadDoneText: 'Uploaded. Click to replace.',
            waring1: 'The video file has exceeded 500MB',
            waring2: 'Please upload a video.',
        },
        video2: {
            title: 'Video Works',
            placeholder: '',
            buttonText: 'Upload Video',
            uploadText: 'Uploading',
            uploadDoneText: 'Uploaded. Click to replace.',
            waring1: 'The video file has exceeded 500MB',
            waring2: 'Please upload a video.',
        },
        optional: {
            title: 'Optional Information',
            placeholder: 'Please fill in the publication title and link here (Maximum 100 characters).',
            waring1: 'Exceeds maximum character limit.',
        },
        optionalInfo: {
            title: 'Other Information',
            placeholder:
                'For previous media-related experience (such as anchor, host, reporter, etc.), you can submit a video file or provide a webpage link. The video file size must not exceed 500MB.',
        },
        // limtTime: 'Submission Deadline: 15 August 2025',
        declaration: {
            title: 'I hereby confirm that I have thoroughly read and agreed to be bound by the terms and conditions of this application form. All information provided in my application is true and accurate.',
            moreText: 'Click to view details.',
            detailTitle: 'Phoenix TV "Host Hunt" Registration Commitment Letter',
            detailText:
                // eslint-disable-next-line no-tabs
                'The organizer of "Host Hunt" is Phoenix TV. This is a selection campaign aimed at recruiting anchor talents for the organizer. Applicants are requested to carefully read the following legal document before registering. Only after fully understanding and agreeing to all the terms of this commitment letter should you complete the registration as instructed on the registration page.<br /><br /><p>1.	Commitment to Abide by Laws and Regulations</p>I hereby declare that I am at least 18 years old at the time of registering for "Host Hunt" possess full civil capacity, am registering independently, and voluntarily make all commitments in this letter. I confirm that I have no record of illegal or disciplinary misconduct, and have not published any statements that violate public order and morals, regulations, or are improper on any form of media, social platforms, or self-media channels, nor have I been involved in any content that breaches laws, regulations, or infringes upon third-party rights. I commit that my participation content complies with national laws, regulations, and public order and good customs. I also confirm that my participation in the selection will not be restricted, prohibited, or limited by any employer or other entities under any law or contract. During and after the selection, I will not, in any form, damage the reputation of the organizer or make any false or misleading statements related to the organizer or the selection event.<br /><br /><p>2.	Commitment to the Authenticity of Basic Information</p>I guarantee that I meet the eligibility requirements stipulated in the announcement for the "Host Hunt" selection campaign. I guarantee that all information provided in my registration is complete, true, and accurate, and is filled out in strict accordance with the requirements. I will not register using false or stolen identity information or personal data. Should any information be verified as false, the organizer has the right to disqualify my participation and reserves the right to pursue legal repercussions. Dishonest behavior will also be recorded and used as a reference for future eligibility reviews.<br /><br /><p>3.	Intellectual Property Commitment</p>I guarantee that the materials submitted for the selection (including but not limited to text, images, videos, audio, etc.) do not infringe upon any third party’s intellectual property rights (including but not limited to copyright), portrait rights, ownership, or other legal rights. Should any disputes arise, I will resolve them myself and bear all related responsibilities. If third-party intellectual property (such as referenced materials) is involved, I pledge that I have obtained authorization from the relevant rights holders and that the scope of authorization meets the needs of this selection.<br /><br /><p>4.	Works Authorization Clause</p>I hereby agree and authorize Phoenix TV and its collaborating parties to:<br />• Use all or part of the submitted materials globally, permanently, and free of charge;<br />• Modify, edit, technically process, and promote the materials by any existing or future means (including but not limited to news dissemination, derivative product development, commercial use, etc.);<br />• Do so without the need for further authorization from myself or any third party, and without any additional payment to myself or any third party.<br /><br /><p>5.	Dispute Liability Clause</p>Should I violate this commitment letter, the organizer has the right to disqualify me, revoke any awards or prizes, and reserves the right to claim compensation for losses from me.<br /><br /><p>6.	Confidentiality Obligation</p>I have (or will) become aware of confidential information related to the selection campaign from the organizer, and I undertake a strict confidentiality obligation. Confidential information includes but is not limited to:<br />6.1 Content, format, and model of the program (selection campaign);<br />6.2 Information and materials related to the program (selection campaign), including but not limited to contestant information, materials, works, information of judges and mentors, program review information, questions and results of each selection stage, internal meeting materials, etc.;<br />6.3 All legal documents, files, and any other information related to the program that cannot be obtained from public channels;<br />6.4 Communication and exchange information with staff.<br /><br /><p>7.	Purpose of Selection</p>I fully acknowledge and accept that "Host Hunt" is a selection campaign aimed at recruiting anchor talents for the organizer.<br /><br /><p>8.	Disclaimer</p>8.1 I undertake that any personal or property loss during the selection period due to my own health, decisions or reasons not attributable to the organizer and shall be borne by myself and is unrelated to the organizer.<br />8.2 I understand and voluntarily waive the right to pursue responsibility should the selection campaign be adjusted or terminated due to force majeure or reasons not attributable to the organizer.<br />8.3 Any disputes arising from the materials I submit (including but not limited to intellectual property rights, such as copyright, portrait rights, ownership, etc.) shall be resolved and borne solely by myself. The organizer and its collaborating parties will not bear any litigation or compensation obligations and reserve the right to claim compensation for losses from me.<br />Note: Legal support for Host Hunt is provided by Yenlex Partners Law Firm, Beijing.<br />',
            promiseText:
                '<p>I solemnly pledge:</p><br />I have fully read, understood, and agreed to all the contents of this commitment letter. The organizer has fully fulfilled its obligation to inform and explain the legal implications of each term and content of this letter to me. By submitting the registration form, I am deemed to have read, understood, and agreed to all the terms, documents, and contents of this commitment letter, and I also undertake to comply with all participation rules and requirements for this selection. The right of interpretation of this commitment letter belongs to the organizer.',
            agreeText: 'Cancel',
            disagreeText: 'Confirm',
            copyText: 'Upload the above content with one click',
        },
        button: {
            submit: 'https://x0.ifengimg.com/ucms/2024_36/2C649CE4D78A71D48F6466D33022144D15F9BF30_size5_w306_h92.png',
            save: 'https://x0.ifengimg.com/ucms/2024_36/AD40FCA880800524C8963B9CAD713A1CA08E581B_size5_w306_h92.png',
        },
        confirm: {
            title1: 'Are you sure to submit the registration information?',
            title2: 'Are you sure to submit updated the registration information?',
            confirmText: 'Confirm',
            checkIt: 'Check again',
        },
        success: {
            title1: 'We have received your information! <br />We will review it and contact you as soon as possible.',
            title2: 'We have received your updated information!<br />We will review it and contact you as soon as possible.',
            info: 'Feedback Email',
        },
        api: {
            waring1: 'Unknown error, submission failed. Please try again later.',
            waring2: 'Please check to acknowledge the information',
        },
        save: {
            title: 'Saved',
        },
        share: {
            // eslint-disable-next-line quotes
            title: "Greater Bay Area Round: Phoenix TV's “Host Hunt” Season 2 recruitment campaign in Guangdong-Hong Kong-Macao Greater Bay Area has begun",
            img: 'https://x0.ifengimg.com/ucms/2025_24/22D5A8C7696250DAF1D64ABAD0DD79CD7C374D51_size230_w600_h600.png',
            desc: 'Do you want to become a Phoenix TV host,  anchor, or on-camera reporter? Sign up now for joining us!',
        },
    },
    ch: {
        banner: {
            title: '凤凰卫视“发现新主播”第二季-粤港澳大湾区专场招募行动开启',
            post: 'https://x0.ifengimg.com/ucms/2025_34/A6C0720D6B9D31A7318F1D88BEFD06F4FC0A60A3_size1329_w750_h1334.png',
            info: 'https://x0.ifengimg.com/ucms/2025_24/80A25CE088ADBEC7F46C2D3BD35ED65FE2EFCF09_size18_w748_h166.png',
            infoText:
                '凤凰卫视「发现新主播」第二季-粤港澳大湾区专场招募行动开启。主持人、主播、出镜记者职位虚席以待，工作地点可在香港、北京或海外。不限职业、资历，只要你有料、有趣、有理想，热爱国际传播事业，就来试试吧。',
            demand: 'https://x0.ifengimg.com/ucms/2025_25/97AC2F77BD29780FF03BEB087CB3F430D3063247_size11_w750_h130.png',
            demandText: '年满18周岁，大学本科及以上学历。',
        },
        name: {
            title: '姓名',
            waring1: '请输入姓名',
            waring2: '已超过最大字数',
        },
        gender: {
            title: '性別',
            man: '男',
            woman: '女',
            selectDefault: '未选择',
            cancelText: '取消',
            confirmText: '确定',
            waring1: '请选择性別',
        },
        age: {
            title: '年龄',
            waring1: '请输入年龄',
            waring2: '最大兩位數',
            waring3: '请输入数字',
        },
        education_level: {
            title: '教育程度',
            placeholder: '如博士/硕士/学士……',
            waring1: '请输入教育程度',
            waring2: '已超过最大字数',
        },
        career: {
            title: '现职',
            placeholder: '如某某公司某某职位',
            waring1: '请输入现职',
            waring2: '已超过最大字数',
        },
        language: {
            title: '语言能力',
            placeholder: '如熟悉英语/粤语/普通话……',
            waring1: '请输入语言能力',
            waring2: '已超过最大字数',
        },
        country: {
            title: '国家/地区',
            waring1: '请输入国家/地区',
            waring2: '已超过最大字数',
        },
        living_city: {
            title: '目前所在城市',
            waring1: '请输入目前所在城市',
            waring2: '已超过最大字数',
        },
        documents: {
            title: '往返粤港澳三地所持证件',
            placeholder: '回乡证/港澳通行证/护照/身份证……',
            waring1: '请输入往返粤港澳三地所持证件',
            waring2: '已超过最大字数',
        },
        mobile_number: {
            title: '手机号',
            waring1: '请输入手机号',
            waring2: '已超过最大字数',
        },
        email: {
            title: '邮箱',
            waring1: '请输入邮箱',
            waring2: '已超过最大字数',
        },
        wechat_id: {
            title: '微信',
            waring1: '请输入微信',
            waring2: '已超过最大字数',
        },
        social_media_accounts: {
            title: '社交网络账号',
            placeholder: 'YouTube/Facebook/Instagram/x等ID或链接',
            waring1: '请输入社交网络账号',
            waring2: '已超过最大字数',
        },
        major: {
            title: '最高学历毕业院校及专业/在读院校及专业',
            placeholder: '某某大学某某专业',
            waring1: '请输入最高学历毕业院校及专业/在读院校及专业',
            waring2: '已超过最大字数',
        },
        work_experience: {
            title: '工作经历/校园经历',
            waring1: '请输入工作经历/校园经历',
            waring2: '已超过最大字数',
        },
        self_introduction: {
            title: '自我介紹',
            placeholder: '40字以內',
            waring1: '请输入自我介绍',
            waring2: '已超过最大字数',
        },
        photo: {
            title: '照片资料',
            placeholder: '参选者两寸照、半身、全身近照各一张,必须为近期所拍摄，图片为jpeg、png、gif、jpg类型。',
            reLoadText: '重新上传',
            defaultImage: 'https://x0.ifengimg.com/ucms/2025_24/1B51D44140BA2A432EBFA9EE8BB98B5E421B0645_size4_w204_h206.png',
            waring1: '图片文件已超过20M',
            waring2: '仅支持jpeg、png、gif、jpg文件上传',
            waring3: '请上传照片',
        },
        video1: {
            title: '视频资料',
            placeholder:
                '自我介绍+分享或者评论最近关注的新闻事件，表现形式不限，能体现报名者个性特点，时长控制在2分钟内。<br /><br />视频注意：<br />1) 长宽比16:9，横幅拍摄，MP4、mov、quicktime格式，大小不超过500MB。<br />2) 画面清晰，声音清楚，无特效处理。',
            buttonText: '点击上传视频',
            uploadText: '上传中',
            uploadDoneText: '已上传，点击替换',
            waring1: '视频文件已超过500M',
            waring2: '请上传视频',
        },
        video2: {
            title: '视频作品',
            placeholder: '',
            buttonText: '点击上传视频',
            uploadText: '上传中',
            uploadDoneText: '已上传，点击替换',
            waring1: '视频文件已超过500M',
            waring2: '请上传视频',
        },
        optional: {
            title: '网页链接',
            placeholder: '请在此处填写发布标题及网页链接，100字以内。',
            waring1: '已超过最大字数',
        },
        optionalInfo: {
            title: '其他相关资料',
            placeholder: '过往跟主播、主持、记者等传媒相关的经历，可提供一个视频文件或者网页链接，视频文件大小不超过500MB。',
        },
        // limtTime: '报名截止日期：2025年8月15日',
        declaration: {
            title: '本人已细阅本报名表格的条款和条文，并同意受其约束。本人报名提供之各项资料，俱属真实。',
            moreText: '点击查看详情',
            detailTitle: '凤凰卫视《发现新主播》报名承诺书',
            detailText:
                '《发现新主播》的主办方是凤凰卫视，是一项以为主办方选聘主播人才为目的的选拔行动。参选者在报名前请认真阅读以下法律文本，在充分了解并理解的基础上同意本承诺书的全部条款后，按照报名页面上的提示完成报名。<br /><br /><p>1. 遵纪守法承诺</p>本人承诺在报名参加《发现新主播》时已年满18周岁，具有完全民事行为能力，独立报名并自愿作出本承诺书的各项承诺。本人承诺无违法、违纪不良记录，在各类媒体、社交平台、自媒体等管道未发表过违反公序良俗、违规或不当言论，且未涉及任何违反法律法规或侵犯第三方权益的内容。本人承诺参选内容符合国家法律法规及公序良俗。本人承诺参加选拔的行为不会受到任何用人单位或其他主体有关法律、合同的约束、禁止或限制。本人承诺参选期间及之后，不会以任何形式损害主办方声誉，不发表任何与主办方或选拔事项相关的虚假或误导性言论。<br /><br /><p>2. 基本信息真实性承诺</p>本人保证符合《发现新主播》选拔行动公告中规定的参选资格要求。本人保证报名填写的内容全面、真实、准确，严格按照要求完整填写信息，不得以虚假或冒用的身份信息、个人资料进行报名。如任何信息被查证失实，主办方有权取消本人参选资格，并保留追究法律责任的权利。同时将不诚信行为记录在案，作为未来参选资格审核的参考依据。<br /><br /><p>3. 知识产权承诺</p>本人保证提交的参选资料（包括但不限于文字、图片、视频、音频等）不侵犯任何第三方知识产权（包括但不限于著作权）、肖像权、所有权等合法权益，如因此发生任何争议纠纷应由本人自行解决并承担全部责任。若涉及第三方知识产权（如引用素材），本人承诺已取得相关权利人授权，并确保授权范围满足本次选拔的使用需求。<br /><br /><p>4. 作品授权条款</p>本人同意并授权凤凰卫视及合作方：<br />• 在全球范围内无偿永久使用参选资料的全部或部分内容；<br />• 以任何现有及未来出现的方式（包括但不限于新闻传播、衍生产品开发、商业用途等）进行修改、编辑、技术处理及推广；<br />• 无需另行取得本人或第三方授权，亦无需向本人或第三方支付额外费用。<br /><br /><p>5. 纠纷责任条款</p>如因本人违反本承诺书，主办方有权取消本人参选资格、追回奖项或奖励，并保留向本人追偿损失的权利。<br /><br /><p>6.保密义务</p>本人已经(或将要)知悉主办方关于选拔行动的保密信息，本人承诺承担严格的保密义务，保密信息包括但不限于：<br />6.1节目（选拔行动）内容、形式及模式；<br />6.2节目（选拔行动）相关信息及资料，包括但不限于选手信息、资料、作品，评委及指导老师信息，节目评审信息、选拔各阶段题目、结果，内部工作会议及相关资料等；<br />6.3节目（选拔行动）涉及的所有法律文书、文件及其他一切无法自公开渠道获知的与节目有关的信息；<br />6.4与工作人员的沟通、交流信息。<br /><br /><p>7.选拔目的</p>本人充分知悉并认可《发现新主播》是一项以为主办方选聘主播人才为目的的选拔行动。<br /><br /><p>8.免责声明</p>8.1本人承诺参选期间因自身健康、非主办方过错导致的本人人身或财产损失，由本人自行承担，与主办方无关。<br />8.2因不可抗力或非主办方过错导致的选拔行动调整或终止，本人予以理解并自愿放弃追责。<br />8.3因本人提交资料引发任何纠纷（包括但不限于知识产权（包括但不限于著作权）、肖像权、所有权等争议或纠纷），由本人自行解决并承担全部责任。主办方及合作方不因此承担任何诉讼或赔偿义务，且保留向本人追偿损失的权利。<br /><br />注：本活动法律支持：北京盈理律师事务所<br />',
            promiseText:
                '<p>本人郑重承诺：</p><br />本人已充分阅读并理解、同意本承诺书全部内容。本承诺书项下各项条款、内容，主办方已向本人充分履行其法律含义的告知、解释义务。本人提交报名表，即被视为已阅读、理解并同意本承诺书的全部条款文件、内容，同时本人承诺遵守本次选拔的所有参选规则和要求。本承诺书解释权归主办方所有。',
            agreeText: '取消',
            disagreeText: '我已知晓并确认',
            copyText: '一键输入以上内容',
        },
        button: {
            submit: 'https://x0.ifengimg.com/ucms/2024_38/068056ECBEF7924A8665BF379448E5C08BFF9099_size5_w306_h92.png',
            save: 'https://x0.ifengimg.com/ucms/2025_24/EC7A456CDA57AC6612F3D87872753C1471C0DEAF_size4_w306_h92.png',
        },
        confirm: {
            title1: '确认提交报名资料吗？',
            title2: '确认更新报名资料吗？',
            confirmText: '确认',
            checkIt: '再检查一下',
        },
        success: {
            title1: '我们已经收到你的资料啦！<br />我们会尽快查看并联络你。',
            title2: '我们已经收到你的更新资料啦！<br />我们会尽快查看并联络你。',
            info: '问题回馈',
        },
        api: {
            waring1: '未知错误，提交失败，请稍后重试',
            waring2: '请确认报名条约',
        },
        save: {
            title: '保存成功',
        },
        share: {
            title: '凤凰卫视“发现新主播”第二季-粤港澳大湾区专场招募行动开启',
            img: 'https://x0.ifengimg.com/ucms/2025_24/22D5A8C7696250DAF1D64ABAD0DD79CD7C374D51_size230_w600_h600.png',
            desc: '想成为凤凰卫视主持人、主播、出镜记者就快来报名参加选拔吧！',
        },
    },
};
